import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { IPackingTrackingHistoryApi } from './base';
import { Result } from '../models/common/resultResponse';
import { GetPrintPdfTagRequest } from '../models/request/packingTrackingHistoryResquest';
import { GetByIdPackingTrackingResponse, GetPrintTagResponse } from '../models/response/packingTrackingHistoryResponse';

const baseRoute: string = 'PackingTrackingHistory';

export class PackingTrackingHistoryApi extends IPackingTrackingHistoryApi {
  get(
    guidPackingTracking: string
  ): Promise<AxiosResponse<Result<GetByIdPackingTrackingResponse[]>>> {
    return api.get(`${baseRoute}/get?guidPackingTracking=${guidPackingTracking}`);
  }

  getPrintZplTag(
    packingTrackingCode: string
  ): Promise<AxiosResponse<Result<GetPrintTagResponse>>> {
    return api.get(`${baseRoute}/getprintzpltag?packingTrackingCode=${packingTrackingCode}`)
  }

  getPrintPdfTag(
    request: GetPrintPdfTagRequest
  ): Promise<AxiosResponse<Result<GetPrintTagResponse>>> {
    return api.get(`${baseRoute}/getprintpdftag`, { params: request })
  }
}